import { addCorrId, loadCorrId } from './utils/correlation_id_store';

// Send webhook to Zapier or any other service
export const webhook = Object.freeze({
  sendPost (url, body, headers = { "Content-Type": "application/json" }) {
    return fetch(url, {
      method: "POST",
      headers: addCorrId(headers),
      body: JSON.stringify(body)
    })
      .then(async (response) => {
        loadCorrId(response.headers);
        return {
          ok: response.ok,
          status: response.status,
          statusText: response.statusText,
          body: await (response.ok ? response.json() : response.text()),
        };
      })
      .catch((error) => {
        return {
          ok: false,
          error
        };
      });
  }
});
